<div
	class="header"
	*ngIf="status === 'premiumUser' || status === 'fetchedContent'"
>
	<div class="first-group">
		<p class="title">
			{{ 'CONTACT.PAGES.CONTENT.TITLE' | translate: { username: firstName } }}
		</p>

		<div class="subtitle">
			<span class="freud-icon freud-icon-shield-check zk-text-success"></span>
			<p
				[innerHTML]="
					'CONTACT.PAGES.CONTENT.SUBTITLE' | translate: { username: firstName }
				"
			></p>
		</div>
	</div>
	<freud-select
		[label]="'CONTACT.FILTER_BY.PERIOD' | translate"
		[options]="periodOptions"
		(valueChange)="this.getContent($event)"
	></freud-select>
</div>


<freud-loader
	class="loading"
	*ngIf="loading"
	size="sm"
	[bgColor]="false"
></freud-loader>

<div
	class="content-wrapper"
	*ngIf="!(status === 'checkingSubscription') && !loading"
>
	<div *ngIf="status === 'fetchedContent'" class="content-list">
		<div class="title">{{ 'CONTACT.PAGES.CONTENT.TITLE_2' | translate }}</div>
		<div class="subtitle">
			{{
				'CONTACT.PAGES.CONTENT.SUBTITLE_2'
					| translate: { number: userContent.contents.length }
			}}
		</div>
		<div class="content-card" *ngFor="let content of userContent.contents">
			<img
				class="cover-img"
				[src]="content.portraitCover || '/assets/images/content-default.svg'"
				[alt]="content.description"
			/>

			<div class="info">
				<p class="title">{{ content.title }}</p>

				<div class="details">
					<div class="time">
						<span freud-icon-base icon="clock" size="16px"></span>
						{{
							'CONTACT.PAGES.CONTENT.DURATION'
								| translate
									: { minutes: content.duration * 1000 | date: 'mm:ss' }
						}}
					</div>

					<div *ngIf="content.type === 'audio'" class="media-type">
						<span freud-icon-base icon="headphones" size="16px"></span>
						{{ 'CONTACT.PAGES.CONTENT.AUDIO' | translate }}
					</div>

					<div class="last-access">
						<span freud-icon-base icon="eye" size="16px"></span>
						{{ 'CONTACT.PAGES.CONTENT.LAST_ACCESS' | translate }}
						{{ content.completion.updatedAt | date: 'dd/MM/yyyy' }}
					</div>
				</div>
			</div>

			<div class="go-to" (click)="goToUrl('conteudo/' + content.slug)">
				<p>{{ 'CONTACT.PAGES.CONTENT.GOTO_CONTENT' | translate }}</p>
				<img
					src="/assets/images/icons/external-link.svg"
					pTooltip="{{ 'CONTACT.PAGES.CONTENT.GOTO_CONTENT' | translate }}"
					alt="{{ 'CONTACT.PAGES.CONTENT.GOTO_CONTENT' | translate }}"
					tooltipPosition="top"
				/>
			</div>
		</div>
	</div>

	<div *ngIf="status === 'noDataAccess'" class="info-card">
		<p
			[innerHtml]="
				'CONTACT.PAGES.CONTENT.ERRORS.REQUEST_DATA_ACCESS'
					| translate: { username: this.contact.displayName }
			"
		></p>

		<freud-button
			color="secondary"
			(click)="openChat()"
			[loading]="loadingChat"
		>
			{{ 'CONTACT.PAGES.CONTENT.REQUEST_ACCESS' | translate }}
		</freud-button>
	</div>

	<div *ngIf="status === 'noContent'" class="info-card">
		<p
			[innerHtml]="
				'CONTACT.PAGES.CONTENT.INFO.NO_CONTENT'
					| translate: { username: this.contact.displayName }
			"
		></p>
	</div>

	<div *ngIf="status === 'basicUser'" class="info-card">
		<p>{{ 'CONTACT.PAGES.CONTENT.INFO.BASIC_USER' | translate }}</p>

		<freud-button color="secondary" (click)="openOfficeUrl('account/premium')">
			{{ 'CONTACT.PAGES.CONTENT.SEE_PLAN' | translate }}
		</freud-button>
	</div>
</div>
